/*
  Cabora Goods — cart-notify.js
  Progressive add-to-cart confirmation. Intercepts any [data-cart-add-form]
  submit, adds via the AJAX Cart API, and shows a small popup ("Keep shopping" /
  "View cart") instead of leaving the page. Also refreshes the header cart count.
  If JS is unavailable or the request fails, the form submits normally and the
  shopper lands on the full cart page — so add-to-cart always works.
*/
(function () {
  'use strict';

  var routes = window.CaboraRoutes || {};
  var addUrl = routes.cart_add || '/cart/add.js';
  var cartUrl = routes.cart || '/cart.js';
  var strings = window.CaboraStrings || {};

  var popup = document.querySelector('[data-cart-notification]');
  var hideTimer = null;

  function showPopup(item) {
    if (!popup) return;
    var img = popup.querySelector('[data-cn-image]');
    var title = popup.querySelector('[data-cn-title]');
    var variant = popup.querySelector('[data-cn-variant]');

    if (item) {
      if (img) {
        if (item.image || item.featured_image) {
          img.src = item.image || (item.featured_image && item.featured_image.url) || '';
          img.hidden = false;
        } else { img.hidden = true; }
      }
      if (title) title.textContent = item.product_title || item.title || '';
      if (variant) {
        var vt = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        variant.textContent = vt;
        variant.hidden = !vt;
      }
    }

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hidePopup, 6000); // auto-dismiss; paused on hover below
  }

  function hidePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  function refreshCount() {
    fetch(cartUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-bubble]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
      })
      .catch(function () { /* non-fatal */ });
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
    var textEl = btn.querySelector('[data-add-to-cart-text]') || btn;
    if (loading) {
      btn.dataset._label = textEl.textContent;
      if (strings.adding) textEl.textContent = strings.adding;
    } else if (btn.dataset._label) {
      textEl.textContent = btn.dataset._label;
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-add-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    setLoading(btn, true);

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          // Out of stock / error → let the normal submit surface Shopify's handling.
          form.submit();
          return;
        }
        var item = res.data.items ? res.data.items[0] : res.data;
        showPopup(item);
        refreshCount();
        setLoading(btn, false);
      })
      .catch(function () { form.submit(); }); // network error → normal navigation to /cart
  });

  // Close actions
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cn-close]')) hidePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hidePopup();
  });
  if (popup) {
    popup.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    popup.addEventListener('mouseleave', function () { hideTimer = setTimeout(hidePopup, 3000); });
  }
})();
